
class SearchTherapistTypes {
 
  constructor(){
      this.id = undefined;
      this.typeName = undefined; 
      this.standardHourlyRate = undefined; 
      this.PagingParams = {
          pageNumber : undefined,
          pageSize : undefined
      };
  }
}

export default SearchTherapistTypes;